module.exports = __webpack_public_path__ + "static/media/redo.dfe613aa.svg";